module.exports = __webpack_public_path__ + "img/equipos-de-sala-img-4.8fff5e8a.jpg";